import React, { useState, useEffect, Fragment } from "react";
import { TrackNowTable } from "../ui";
import { IconButton, Checkbox } from "@mui/material";
import { GoogleIconButton } from "../ui/GoogleIconButton";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { Box } from "@mui/material";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from '../../theme/tokens';
const PostAwardApproverTable = ({
  isMaster,
  tableData,
  isDefaultChange,
  handleDelete,
  setSelectedRow,
  selectedRow,
  setSelectedRecord
}) => {
  const [expandedRows, setExpandedRows] = useState({});
  const [approverSelected, setApproverSelected] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const selectRecord = (id) => {
    let newSelectedList;
    if (approverSelected.includes(id)) {
      newSelectedList = approverSelected.filter(item => item !== id);
    } else {
      newSelectedList = [...approverSelected, id];
    }
    setSelectedRecord(newSelectedList);
    setApproverSelected(newSelectedList);
  };

  const toggleRow = (clientName) => {
    setExpandedRows(prev => ({
      ...prev,
      [clientName]: !prev[clientName]
    }));
    if (!expandedRows[clientName]) {
      setSelectedRow(clientName);
      setSelectedRecord([]);
      setApproverSelected([]);
    }
  };

  useEffect(() => {
    const rows = [];

    console.log('PostAwardApproverTable - tableData:', tableData);
    console.log('PostAwardApproverTable - isMaster:', isMaster);

    if (!tableData || typeof tableData !== 'object') {
      console.log('No tableData or invalid tableData');
      setTableRows([]);
      return;
    }

    for (const client in tableData) {
      // Add main client row
      rows.push({
        id: `client-${client}`,
        clientName: client,
        isClientRow: true,
        isExpanded: expandedRows[client]
      });

      // Add detail rows if expanded
      if (expandedRows[client]) {
        const clientData = isMaster ? tableData[client] : tableData[client];
        const detailRows = isMaster ?
          clientData.map(ele => ({
            id: ele.id,
            clientName: '',
            jurisdiction: ele.juristiction,
            state: ele.state,
            isDefault: ele.isdefault,
            approverName: ele.approverName,
            isDetailRow: true,
            originalData: ele
          })) :
          Object.entries(clientData).flatMap(([key, value]) =>
            value.map(ele => ({
              id: ele.id,
              clientName: '',
              jurisdiction: ele.juristiction,
              state: ele.state,
              isDefault: ele.isdefault,
              approverName: ele.approverName,
              isDetailRow: true,
              originalData: ele
            }))
          );

        rows.push(...detailRows);
      }
    }

    console.log('Generated table rows:', rows);
    setTableRows(rows);
  }, [tableData, expandedRows, isMaster]);

  const columns = [
    {
      id: 'expand',
      label: '',
      minWidth: 50,
      renderCell: (value, row) => {
        if (row.isClientRow) {
          return (
            <GoogleIconButton
              iconName={row.isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
              iconSize="small"
              iconColor={primaryColor}
              size="small"
              onClick={() => toggleRow(row.clientName)}
              sx={{
                '&:hover': {
                  backgroundColor: `${primaryColor}1A`,
                },
                '& .MuiTouchRipple-root .MuiTouchRipple-child': {
                  backgroundColor: primaryColor,
                },
              }}
            />
          );
        }
        return (
          <Checkbox
            checked={approverSelected.includes(row.id)}
            onClick={() => selectRecord(row.id)}
            sx={{
              color: tokens.colors.midGrey,
              '&.Mui-checked': {
                color: primaryColor,
              },
              '&:hover': {
                backgroundColor: `${primaryColor}1A`,
              },
            }}
          />
        );
      }
    },
    {
      id: 'clientName',
      label: isMaster ? 'State/Jurisdiction' : 'Client Name',
      minWidth: 200,
      renderCell: (value, row) => {
        if (row.isClientRow) {
          return row.clientName;
        }
        return '';
      }
    },
    {
      id: 'jurisdiction',
      label: 'Jurisdiction',
      minWidth: 120,
      renderCell: (value, row) => row.isDetailRow ? row.jurisdiction : ''
    },
    {
      id: 'state',
      label: 'State',
      minWidth: 100,
      renderCell: (value, row) => row.isDetailRow ? row.state : ''
    },
    {
      id: 'isDefault',
      label: 'Default',
      minWidth: 80,
      renderCell: (value, row) => {
        if (!row.isDetailRow) return '';
        return (
          <Checkbox
            checked={row.isDefault}
            disabled={row.isDefault}
            onChange={(e) => {
              if (isMaster) {
                isDefaultChange(e, row.state, row.originalData.approverId);
              } else {
                isDefaultChange(
                  e,
                  row.originalData.client,
                  row.state,
                  row.originalData.approverId,
                  row.originalData.customerId
                );
              }
            }}
          />
        );
      }
    },
    {
      id: 'approverName',
      label: 'Approver Names',
      minWidth: 200,
      renderCell: (value, row) => row.isDetailRow ? row.approverName : ''
    },
    {
      id: 'actions',
      label: 'Actions',
      minWidth: 80,
      renderCell: (value, row) => {
        if (!row.isDetailRow) return '';
        return (
          <GoogleIconButton
            iconName="delete"
            iconSize="medium"
            iconColor={primaryColor}
            size="medium"
            onClick={() => {
              if (isMaster) {
                handleDelete(
                  row.state,
                  row.id,
                  row.isDefault,
                  row.approverName
                );
              } else {
                handleDelete(
                  row.originalData.client,
                  row.state,
                  row.id,
                  row.isDefault,
                  row.approverName
                );
              }
            }}
            sx={{
              '&:hover': {
                backgroundColor: `${primaryColor}1A`,
              },
              '& .MuiTouchRipple-root .MuiTouchRipple-child': {
                backgroundColor: primaryColor,
              },
            }}
          />
        );
      }
    }
  ];

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <TrackNowTable
        columns={columns}
        rows={tableRows}
      />
    </Box>
  );
};

export default PostAwardApproverTable;
